module.exports = __webpack_public_path__ + "static/media/Hair03.8cfde79b.jpeg";